<template>
	<div class="full zhe">
		<div class="hb_ele2" v-if="!moneyShow">
			<img src="../img/hb_ele2.png" />
			<div class="hb_ele1" v-hammer:tap="getHb"><img src="../img/hb_ele1.png" /></div>
		</div>
		<div class="hb_ele3" v-if="moneyShow">
			<img src="../img/hb_ele3.png" />
			<div class="hb_num">￥{{money}}</div>
		</div>
		<div class="box_back" v-hammer:tap="back"><img src="../img/box_back.png" /></div>
	</div>
</template>

<style scoped>
.hb_ele1{
	position: absolute;
	width: 33.1%;
	left: 34.1%;
	top: 57.1%;	
}
.hb_ele2{
	position: absolute;
	width: 81.7%;
	left: 9.2%;
	top: 21.4%;
}
.hb_ele3{
	position: absolute;
	width: 71.9%;
	left: 13.2%;
	top: 25.6%;
}
.hb_num{
	position: absolute;
	width: 100%;
	top: 18%;
	color: #e10017;
	text-align: center;
	font-size: 12vw;
	font-weight: bolder;
}
.box_back{
	position: absolute;
	width: 10%;
	top: 70%;
	left: 45%;
}
</style>
<script>
	export default {
		data() {
			return {
				money:0,
				moneyShow:false
			};
		},
		computed: {

		},
		mounted() {

		},
		watch: {

		},
		methods: {
			getHb(){
				this.$api.getHongbao().then((res)=>{
					this.money = res
					this.moneyShow = true
				})
				
			},
			back(){
				this.$emit('back')
			}
		},
		components: {

		}
	}
</script>
